import {
    SET_CONSULTANTS_LOADING,
    SET_CONSULTANTS_ERROR,
    FETCH_CONSULTANTS_SUCCESS,
    FETCH_CONSULTANTS_FAIL,
    CREATE_CONSULTANT_FAIL,
    UPDATE_CONSULTANT_FAIL,
    DELETE_CONSULTANT_SUCCESS,
    DELETE_CONSULTANT_FAIL,
} from "../actions/consultantsActions";

const initialState = {
    loading: false,
    error: null,
    consultants: [],
};

export default function consultantsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CONSULTANTS_LOADING:
            return { ...state, loading: action.payload };
        case SET_CONSULTANTS_ERROR:
            return { ...state, error: action.payload };

        case FETCH_CONSULTANTS_SUCCESS:
            return { ...state, consultants: action.payload || [], error: null };

        case FETCH_CONSULTANTS_FAIL:
        case CREATE_CONSULTANT_FAIL:
        case UPDATE_CONSULTANT_FAIL:
        case DELETE_CONSULTANT_FAIL:
            return { ...state, error: action.payload };

        case DELETE_CONSULTANT_SUCCESS:
            return { ...state, consultants: state.consultants.filter((x) => x.id !== action.payload), error: null };

        default:
            return state;
    }
}
